import React from "react";
import { useNavigate } from "react-router";
import { motion } from "framer-motion";
import { FaPlus } from "react-icons/fa";
import { useCreateConversation, useConversations } from "@/api/conversation";
import logger from "@/utils/logger";

const NewConversationButton: React.FC = () => {
  const navigate = useNavigate();
  const { data: conversations = [], refetch } = useConversations();
  const createConversationMutation = useCreateConversation();

  const handleCreateConversation = async () => {
    try {
      const newConversation = await createConversationMutation.mutateAsync({
        name: `Conversation ${conversations.length + 1}`,
      });
      refetch();
      if (newConversation?.id) {
        navigate(`/chat?id=${newConversation.id}`);
      }
    } catch (error) {
      logger.error("Failed to create conversation:", error);
    }
  };

  return (
    <div className="px-3 py-2">
      <motion.button
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={handleCreateConversation}
        disabled={createConversationMutation.isPending}
        className={`w-full flex items-center justify-center gap-2 px-3 py-2 rounded-lg border border-dashed transition-all
          border-[var(--arc-sidebar-border-accent)] text-[var(--arc-sidebar-text-secondary)] 
          hover:text-[var(--arc-sidebar-text-primary)] hover:border-[var(--arc-accent)] hover:bg-[var(--arc-sidebar-accent-glow)]
          disabled:opacity-50 disabled:cursor-not-allowed
        `}
      >
        <FaPlus size={12} />
        <span className="text-sm">New Conversation</span>
      </motion.button>
    </div>
  );
};

NewConversationButton.displayName = "NewConversationButton";

export default NewConversationButton;
